import Cookies from "js-cookie";

export const getHeaderAuthBearerToken = () => {
  return Cookies.get("auth-token") ? "bearer " + Cookies.get("auth-token") : "";
};

export const getAuthLocalStorage = () => {
  var auth =
    localStorage.getItem("auth-token") !== null
      ? JSON.parse(localStorage.getItem("auth-token"))
      : null;
  return auth;
};
